import { axiosHrClient } from '../plugins/axios'

const reference = {
  namespaced: true,

  actions: {
    getEducationLevel() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrreference/eduleveloverbachelor`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getCountry() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrreference/country`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getStudentSchorlarType() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrreference/studyscolartype`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default reference
